// extracted by mini-css-extract-plugin
module.exports = {"region-suggest":"e462cbfa4b--region-suggest--W71MI","suggests":"e462cbfa4b--suggests--INT12"};